import { Flag, Clock, PencilLine } from "lucide-react";
import { TutorialRating } from "../tutorial/TutorialRating";

interface TutorialMetadataProps {
  creatorName: string;
  updatedTimeAgo: string;
  completedCount: number;
  duration: string;
  rating: number;
}

export function TutorialMetadata({
  creatorName,
  updatedTimeAgo,
  completedCount,
  duration,
  rating,
}: TutorialMetadataProps) {
  return (
    <div className="flex items-center gap-4 text-sm text-muted-foreground">
      <span className="font-medium text-foreground">{creatorName}</span>
      <div className="flex items-center">
        <PencilLine className="w-4 h-4" />
        <span className="ml-1">{updatedTimeAgo}</span>
      </div>
      <div className="flex items-center">
        <Flag className="w-4 h-4" />
        <span className="ml-1">{completedCount}</span>
      </div>
      <div className="flex items-center">
        <Clock className="w-4 h-4" />
        <span className="ml-1">{duration}</span>
      </div>
      <TutorialRating rating={rating} />
    </div>
  );
}
